
           
             <div class="row row-replace m-t-30">
                 <div class="col-12">
                     <div style="background-image:url('./assets/img/back/hyderabad.png');width:600px;height:1000px;border:1px solid black;margin:0 auto;" class="zoom">
                    
                        <button class="btn btn-sm btn-success setAv" *ngFor="let x of numb" [ngStyle]="{'margin':x.xy}" (click)="openModal('#seat_config', x)">{{x.n}}</button>

                    </div>
                 </div>
             </div>

             <!-- <div id="seat_config" class="modal  custom-modal fade"  role="dialog">
                <div class="modal-dialog   modal-dialog-centered modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> 
             
                        <div class="modal-body">
                            <app-seat-config [seatNo]="seat" *ngIf="seat"></app-seat-config>
                        </div>
                        
                    </div>
                 </div>
              </div> -->

             

